var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconRewardsWhite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.99178 5.24628C6.9715 5.24628 5.3335 6.88428 5.3335 8.90514C5.3335 10.926 6.97121 12.5643 8.99178 12.5643C11.0129 12.5643 12.6512 10.9263 12.6512 8.90514C12.6509 6.88457 11.0129 5.24628 8.99178 5.24628Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.7029 2.61657C6.17118 -0.851144 11.8132 -0.851144 15.2806 2.616C18.7486 6.08428 18.7486 11.7263 15.2806 15.1946C11.8135 18.6617 6.17118 18.662 2.7029 15.1937C-0.764533 11.7263 -0.763961 6.084 2.7029 2.61657ZM6.33318 15.5983C8.92404 16.6234 11.9932 16.0909 14.0855 13.9986C16.1778 11.9063 16.71 8.83714 15.6852 6.246C14.6209 6.36228 13.5149 6.01457 12.6986 5.19828C11.8826 4.38257 11.5352 3.27686 11.6515 2.212C9.06032 1.18686 5.99147 1.71971 3.8989 3.812C1.80632 5.90428 1.27375 8.97371 2.2989 11.5643C3.36347 11.4477 4.46918 11.7954 5.28547 12.6117C6.10204 13.4277 6.44947 14.5334 6.33318 15.5983Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconRewardsWhite);
export default __webpack_public_path__ + "static/media/icon-rewards-white.59aee065.svg";
export { ForwardRef as ReactComponent };